//local
// const BASE_URL = "http://192.168.9.2:5200/node_api/";
//demo
// const BASE_URL = "http://162.19.146.135:1738/";


// const BASE_URL = "http://72.167.224.9:5000/";

// const BASE_URL = "https://admin.humansolutioninc.com/node_api/";


//demo
//  const BASE_URL = "https://sydney.admin.infinitemlmdemo.com/node_api/";

//live
const BASE_URL = "https://admin.humansolutioninc.com/node_api/";

const DEFAULT_KEY = 'SYDNEYxJXmzCWE3lZiCvGLSNjaBsX5Jo3n5y4wexRoKRFdqECorZFUe7IckdHpvXhJTVRnbDlEUqpkgD42uQGdqANk7OtY4skDIJUS6a8OMK9QX0sRVpypor5IP40Vrg'


const PAYPAL_CLIENT_ID = "ATtY3CotjXVye4iosAlVI4cuihnv8nNg_Y8R-dRLWPe_-GawRjLbtKqZxlSfP6XDOJlbvMR0I4ziL0a_"

export { BASE_URL, DEFAULT_KEY, PAYPAL_CLIENT_ID }
